import React from 'react';
import styled from 'styled-components';
import { Spinner } from 'react-bootstrap';

const SpinnerContainer = styled.div`
	width: 100%;
	height: 100%;
	text-align: center;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const Loading = () => {
	return (
		<SpinnerContainer>
			<Spinner animation="grow" />
		</SpinnerContainer>
	);
};

export default Loading;
